module.exports = __webpack_public_path__ + "img/breadcrumb.c88a0ad5.svg";